import React from 'react';
import { Spinner } from "react-bootstrap";
import { SuspenseContainer } from './SuspenseFallback.style'

/**
 * SuspenseFallback
 * @param props the list of props.
 * @returns The html context of suspense fallback.
 */
export function SuspenseFallback(props) {
    return (
        <SuspenseContainer>
            <Spinner animation="border" />
        </SuspenseContainer>
    );
}